// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".adaptive-image-new{position:relative;overflow:hidden;width:100%}.adaptive-image-new-lqip{position:absolute;top:0;left:0;z-index:0;width:100%;height:100%}.adaptive-image-new img{position:relative;width:100%;max-width:100%;height:100%;transition:opacity .25s ease}.adaptive-image-new img.lazyload,.adaptive-image-new img.lazyloading{opacity:0}.adaptive-image-new img.lazyloaded{opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
